module.exports = __webpack_public_path__ + "static/media/top-arrow.40ba9772.svg";